import GoldCoinIcon from "./gold-coin-icon";

export const formatPrice = (amount: number, currency: string): [string,string] => {
  if (currency === "TL") {
    currency = "TRY";
  }
  let valStr;
  if (currency === "GAU") {
    valStr = (Math.round(amount*100) / 100).toFixed(2);
  } else {
    // Add commas to every third digit
    // Also, print in two decimal places
    // Example: 123,456.00
    valStr = new Intl.NumberFormat(currency === "TRY" ? "tr-TR" : "en-US", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: currency,
    }).format(amount);
  }
  return [
    valStr.slice(0, -3),
    valStr.slice(-3)
  ];
}

export function PriceView({ amount, currency, smaller }: { amount: number, currency: string, smaller?: boolean }) {
  let decimalClassName = smaller 
    ? "text-[0.5em] relative -top-[0.3em]" 
    : "text-[0.7em] relative -top-[0.3em]"
  let iconSize = smaller
    ? 10
    : 13;
  let iconClass = smaller
    ? 'mb-1'
    : 'mb-1'
  const [price,decimal] = formatPrice(amount, currency);
  return (
    <span className={currency==="GAU" ? "text-amber-300" : "text-green-300"}>
      { 
        currency === "GAU" ? (
          <GoldCoinIcon size={iconSize} className={`inline-block ${iconClass}`} />
        ) : null
      }
      {price}
      <span className={decimalClassName}>
        {decimal}
      </span>
    </span>
  )
}